import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export async function joinWaitlist({ email, company_size, source }) {
    const res = await axios.post(`${API}/waitlist`, {
        email,
        company_size: company_size || null,
        source: source || "hero",
    });
    return res.data;
}

export async function getWaitlistCount() {
    try {
        const res = await axios.get(`${API}/waitlist/count`);
        return res.data.count;
    } catch {
        return null;
    }
}

export const COMPANY_SIZES = [
    { value: "1-10", label: "1 – 10" },
    { value: "11-50", label: "11 – 50" },
    { value: "51-200", label: "51 – 200" },
    { value: "201-1000", label: "201 – 1,000" },
    { value: "1000+", label: "1,000+" },
];
